import NProgress from 'nprogress'

const afterEach = (to, from, next) => {
  NProgress.done();
};
export default afterEach;


// WEBPACK FOOTER //
// ./src/router/afterEach.js